import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@material-ui/core';

import { textInCapitalCase } from '../../../../../helpers/TextHelper';
import { formatDateWithoutTime } from '../../../../../helpers/DateFormatter';
import { iconChooser } from '../../../../../helpers/IconHelper';
import { priceFormatter } from '../../../../../helpers/ProductHelper';
import { useProductCollapseHeaderStyles } from './styles';

const ProductCollapseHeader = ({ ...props }) => {
  const {
    isMkp,
    name,
    dateText,
    purchaseDate,
    totalPrice,
    expanded,
    mouseOver,
  } = props;
  const classes = useProductCollapseHeaderStyles({ expanded, mouseOver });

  return (
    <Box display="flex" padding="32px" paddingLeft="16px">
      <img className={classes.image} src={iconChooser(isMkp)} />
      <Box className={classes.container}>
        <Typography className={classes.textName} variant="h4">
          {textInCapitalCase(name)}
        </Typography>
        <Typography className={classes.text} variant="h4">
          <strong>{dateText || 'Fecha de compra:'} </strong>
          {formatDateWithoutTime(purchaseDate)}
        </Typography>
        {totalPrice && (
          <Typography className={classes.text} variant="h4">
            <strong>Precio producto:&nbsp;</strong>
            {priceFormatter(totalPrice)}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

ProductCollapseHeader.propTypes = {
  isMkp: PropTypes.bool,
  name: PropTypes.string,
  dateText: PropTypes.string,
  purchaseDate: PropTypes.string,
  totalPrice: PropTypes.number,
  expanded: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  mouseOver: PropTypes.bool,
};

export default ProductCollapseHeader;
